(function($){
    if($('body').hasClass('search-results')){
        if($('#woocommerce-product-search-field-0').val() != ''){
            $('[data-elementor-type="product-archive"]').prepend('<div class="search-head"><h1 class="elementor-heading-title elementor-size-default">Wyszukiwanie: '+$('#woocommerce-product-search-field-0').val()+'</h1></div>');
        }
    }
})(jQuery)